import React, { useEffect, useMemo, useRef, useState } from "react";
import { Chip } from "../chip/chip";
import "./card.css";

const SECTION_INDEX = {
 purpose: "01",
 services: "02",
 technologies: "03",
 contacts: "04",
};

export function Card({ props }) {
 const ref = useRef(null);
 useOnScreen(ref);

 const card = props.card;

 return (
  <section key={card.key} ref={ref} className={`sf-section reveal section-${card.key}`} id={card.key}>
   <div className="section-head">
    <span className="section-index mono">/{SECTION_INDEX[card.key] || "00"}</span>
    <h2 className="section-title" dangerouslySetInnerHTML={{ __html: card.header }}></h2>
    <div className="section-rule"></div>
   </div>
   {card.description && (
    <p className="section-sub" dangerouslySetInnerHTML={{ __html: card.description }}></p>
   )}

   {determineContent(card.key, card.content)}
  </section>
 );
}

export const trackPointer = (e) => {
 const rect = e.currentTarget.getBoundingClientRect();
 e.currentTarget.style.setProperty("--px", `${e.clientX - rect.left}px`);
 e.currentTarget.style.setProperty("--py", `${e.clientY - rect.top}px`);
};

const determineContent = (type, content) => {
 switch (type) {
  case "services":
   return (
    <div className="services-grid">
     {content.map((cont, idx) => (
      <article key={idx} className="service-card" onMouseMove={trackPointer}>
       <div className="service-icon">
        <i className={cont.icon}></i>
       </div>
       <h3 className="service-title">{cont.title}</h3>
       <div className="service-text" dangerouslySetInnerHTML={{ __html: cont.text }}></div>
       <div className="service-card-glow"></div>
      </article>
     ))}
    </div>
   );
  case "purpose":
   return (
    <div className="purpose-block">
     <div className="purpose-quote mono">&lt;purpose&gt;</div>
     <h3 className="purpose-title">{content.title}</h3>
     <p className="purpose-text">{content.text}</p>
     <div className="purpose-quote mono">&lt;/purpose&gt;</div>
    </div>
   );
  case "contacts":
   return (
    <div className="contacts-grid">
     <div className="contacts-pitch">
      <p>{content.subDescription}</p>
     </div>
     <div className="contacts-panel">
      <div className="contacts-panel-header mono">{"// get in touch"}</div>
      {content.email && (
       <div className="contact-row">
        <span className="contact-label mono">email</span>
        <a href={`mailto:${content.email}`}>{content.email}</a>
       </div>
      )}
      {content.phone && (
       <div className="contact-row">
        <span className="contact-label mono">phone</span>
        <span>{content.phone}</span>
       </div>
      )}
      {content.address && (
       <div className="contact-row">
        <span className="contact-label mono">address</span>
        <span>{content.address}</span>
       </div>
      )}
     </div>
    </div>
   );
  case "technologies":
   return (
    <div className="card-chips">
     {content.map((item, idx) => (
      <Chip key={idx} props={{ name: item.name, icon: item.icon }} />
     ))}
    </div>
   );
  default:
   return <div></div>;
 }
};

export default function useOnScreen(ref) {
 const observer = useMemo(
  () =>
   new IntersectionObserver(
    ([entry], obs) => {
     if (entry.isIntersecting) {
      entry.target.classList.add("show");
      obs.unobserve(entry.target);
     }
    },
    {
     rootMargin: "0px 0px -80px 0px",
    }
   ),
  []
 );

 useEffect(() => {
  observer.observe(ref.current);
  return () => observer.disconnect();
 }, [observer, ref]);
}

export const useCheckMobileScreen = (widthSize = 1100) => {
 const [width, setWidth] = useState(window.innerWidth);
 const handleWindowSizeChange = () => {
  setWidth(window.innerWidth);
 };

 useEffect(() => {
  window.addEventListener("resize", handleWindowSizeChange);
  return () => {
   window.removeEventListener("resize", handleWindowSizeChange);
  };
 }, []);

 return width <= widthSize;
};
